import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';

import { AppContextProvider } from '@contexts/AppContext';
import useEventTracking from '@hooks/useEventTracking';
import { Page, TrackingLocation } from '@tracking';

import OrgChartsContent from './Content';
import { AppContextOrgChartsProps, OrgChartContentProps } from './interfaces';

type OrgChartPageProps = OrgChartContentProps & AppContextOrgChartsProps;

const queryClient = new QueryClient();

const OrgCharts = ({
  env,
  initialCurrentUser,
  isGdprRequired,
  isWebview,
  title,
  description,
  companies,
}: OrgChartPageProps) => {
  const { Track } = useEventTracking({
    location: TrackingLocation.OrgChartIndex,
    page: Page.OrgChartIndex,
  });

  return (
    <AppContextProvider
      env={env}
      initialCurrentUser={initialCurrentUser}
      isGdprRequired={isGdprRequired}
      isWebview={isWebview}
    >
      <QueryClientProvider client={queryClient}>
        <Track>
          <OrgChartsContent
            title={title}
            description={description}
            companies={companies}
            initialCurrentUser={initialCurrentUser}
          />
        </Track>
      </QueryClientProvider>
    </AppContextProvider>
  );
};

export default OrgCharts;
